import Vue from 'vue'
import Vuex from 'vuex'
import cacheModule from './cache-module'
import visualPlugin from './visual-plugin'

import gql from 'graphql-tag'
import { apiQL } from '@/api'

const SET_STUFF = 'SET_STUFF'
const SET_WASTE = 'SET_WASTE'
const SET_SERVICES = 'SET_SERVICES'
const SET_PAGES = 'SET_PAGES'
const SET_GLOBALS = 'SET_GLOBALS'
const SET_SOCIALS = 'SET_SOCIALS'

Vue.use(Vuex)
export default new Vuex.Store({
  plugins: [visualPlugin],
  state: {
    updatePage: {
      slug: 'nieuws',
      title: 'Nieuws',
      typeHandle: 'nieuws',
    },
    pages: [],
    stuff: [],
    waste: [],
    services: [],
    globals: {},
    socials: {},
    loading: false,
  },
  mutations: {
    loading(state, flag) {
      state.loading = flag
    },
    SET_PAGES(state, pages) {
      state.pages = pages
    },
    SET_STUFF(state, stuff) {
      state.stuff = stuff
    },
    SET_WASTE(state, waste) {
      state.waste = waste
    },
    SET_SERVICES(state, services) {
      state.services = services
    },
    SET_GLOBALS(state, globals) {
      state.globals = globals
    },
    SET_SOCIALS(state, socials) {
      state.socials = socials
    },
  },
  getters: {
    sections: (state) => {
      return [
        {
          handle: 'stuff',
          title: state.globals.titleStuff || 'Stuff',
        },
        {
          handle: 'waste',
          title: state.globals.titleWaste || 'Waste',
        },
        {
          handle: 'services',
          title: state.globals.titleServices || 'Services',
        },
      ]
    },
    allPages: (state) => {
      return [...state.pages, state.updatePage]
    },
    items: (state) => {
      return [...state.services, ...state.waste, ...state.stuff]
    },
  },
  actions: {
    async loadItems({ commit }) {
      try {
        const q = gql`
          query {
            waste: entries(type: ["waste"]) {
              id
              slug
              title
              sectionHandle
              ... on waste_waste_Entry {
                explanation
                image {
                  url @transform(width: 150, mode: "fit", immediately: true)
                }
              }
            }
            stuff: entries(type: ["stuff"]) {
              id
              slug
              title
              sectionHandle
              ... on stuff_stuff_Entry {
                explanation
                image {
                  url @transform(width: 150, mode: "fit", immediately: true)
                }
              }
            }
            services: entries(type: ["services"]) {
              id
              slug
              title
              sectionHandle
              ... on services_services_Entry {
                explanation
                image {
                  url @transform(width: 150, mode: "fit", immediately: true)
                }
              }
            }
          }
        `
        const result = await apiQL(q)
        this.stuff = result.data.stuff
        this.waste = result.data.waste
        this.services = result.data.services
        commit(SET_STUFF, result.data.stuff)
        commit(SET_WASTE, result.data.waste)
        commit(SET_SERVICES, result.data.services)
      } catch (error) {
        console.warn(error)
      }
    },
    async loadSocials({ commit }) {
      try {
        const q = gql`
          query {
            globalSet(handle: "Settings") {
              ... on settings_GlobalSet {
                mainIllustration {
                  url @transform(width: 600, mode: "fit", immediately: true)
                }
                logo {
                  url @transform(width: 300, mode: "fit", immediately: true)
                }
                logoVideos {
                  url @transform(width: 250, mode: "fit", immediately: true)
                }
                logoQuotes {
                  url @transform(width: 250, mode: "fit", immediately: true)
                }
                socialLinks {
                  ... on socialLinks_socialLink_BlockType {
                    display
                    socialUrl
                    image {
                      url @transform(width: 150, mode: "fit", immediately: true)
                    }
                  }
                }
              }
            }
          }
        `
        const result = await apiQL(q)

        commit(SET_SOCIALS, result.data.globalSet)
      } catch (error) {
        console.log(error)
        this.error = error
      }
    },
    async loadGlobals({ commit }) {
      try {
        const q = gql`
          query {
            globalSet(handle: "text") {
              ... on text_GlobalSet {
                slogan
                statementWaste
                statementGlobal
                statementServices
                statementStuff
                explanationWaste
                explanationGlobal
                explanationServices
                explanationStuff
                titleServices
                titleStuff
                titleWaste
              }
            }
          }
        `
        const result = await apiQL(q)
        commit(SET_GLOBALS, result.data.globalSet)
      } catch (error) {
        console.log(error)
        this.error = error
      }
    },
    async loadPages({ commit }) {
      try {
        const q = gql`
          query {
            pages: entries(type: ["page"]) {
              ... on pages_page_Entry {
                slug
                title
                typeHandle
                mainText
              }
            }
          }
        `
        const result = await apiQL(q)
        this.stuff = result.data.pages
        commit(SET_PAGES, result.data.pages)
      } catch (error) {}
    },
  },
  modules: {
    cache: cacheModule,
  },
})
